/* eslint-disable */
// prettier-ignore
import * as Types from '../../../../../../../../../../graphql/__generated__';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DupeIndicationBanner_IndicationEntityKeyQueryVariables = Types.Exact<{
  offeringId: Types.Scalars['UUID']['input'];
  indicationId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
}>;

export type DupeIndicationBanner_IndicationEntityKeyQuery = {
  readonly __typename?: 'Query';
  readonly institutionalIndication?: {
    readonly __typename?: 'InstitutionalIndication';
    readonly id: string;
    readonly investorInformation: {
      readonly __typename?: 'InvestorInformation';
      readonly bankInvestorName?: string | null;
      readonly cmgEntityName: string;
      readonly cmgEntityKey: string;
    };
  } | null;
};

export const DupeIndicationBanner_IndicationEntityKeyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DupeIndicationBanner_IndicationEntityKey' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offeringId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'indicationId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'institutionalIndication' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offeringId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offeringId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'indicationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'indicationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'investorInformation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'bankInvestorName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cmgEntityName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cmgEntityKey' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useDupeIndicationBanner_IndicationEntityKeyQuery__
 *
 * To run a query within a React component, call `useDupeIndicationBanner_IndicationEntityKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useDupeIndicationBanner_IndicationEntityKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDupeIndicationBanner_IndicationEntityKeyQuery({
 *   variables: {
 *      offeringId: // value for 'offeringId'
 *      indicationId: // value for 'indicationId'
 *   },
 * });
 */
export function useDupeIndicationBanner_IndicationEntityKeyQuery(
  baseOptions: Apollo.QueryHookOptions<
    DupeIndicationBanner_IndicationEntityKeyQuery,
    DupeIndicationBanner_IndicationEntityKeyQueryVariables
  > &
    (
      | { variables: DupeIndicationBanner_IndicationEntityKeyQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DupeIndicationBanner_IndicationEntityKeyQuery,
    DupeIndicationBanner_IndicationEntityKeyQueryVariables
  >(DupeIndicationBanner_IndicationEntityKeyDocument, options);
}
export function useDupeIndicationBanner_IndicationEntityKeyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DupeIndicationBanner_IndicationEntityKeyQuery,
    DupeIndicationBanner_IndicationEntityKeyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DupeIndicationBanner_IndicationEntityKeyQuery,
    DupeIndicationBanner_IndicationEntityKeyQueryVariables
  >(DupeIndicationBanner_IndicationEntityKeyDocument, options);
}
// @ts-ignore
export function useDupeIndicationBanner_IndicationEntityKeySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DupeIndicationBanner_IndicationEntityKeyQuery,
    DupeIndicationBanner_IndicationEntityKeyQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  DupeIndicationBanner_IndicationEntityKeyQuery,
  DupeIndicationBanner_IndicationEntityKeyQueryVariables
>;
export function useDupeIndicationBanner_IndicationEntityKeySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DupeIndicationBanner_IndicationEntityKeyQuery,
        DupeIndicationBanner_IndicationEntityKeyQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  DupeIndicationBanner_IndicationEntityKeyQuery | undefined,
  DupeIndicationBanner_IndicationEntityKeyQueryVariables
>;
export function useDupeIndicationBanner_IndicationEntityKeySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DupeIndicationBanner_IndicationEntityKeyQuery,
        DupeIndicationBanner_IndicationEntityKeyQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    DupeIndicationBanner_IndicationEntityKeyQuery,
    DupeIndicationBanner_IndicationEntityKeyQueryVariables
  >(DupeIndicationBanner_IndicationEntityKeyDocument, options);
}
export type DupeIndicationBanner_IndicationEntityKeyQueryHookResult = ReturnType<
  typeof useDupeIndicationBanner_IndicationEntityKeyQuery
>;
export type DupeIndicationBanner_IndicationEntityKeyLazyQueryHookResult = ReturnType<
  typeof useDupeIndicationBanner_IndicationEntityKeyLazyQuery
>;
export type DupeIndicationBanner_IndicationEntityKeySuspenseQueryHookResult = ReturnType<
  typeof useDupeIndicationBanner_IndicationEntityKeySuspenseQuery
>;
export type DupeIndicationBanner_IndicationEntityKeyQueryResult = Apollo.QueryResult<
  DupeIndicationBanner_IndicationEntityKeyQuery,
  DupeIndicationBanner_IndicationEntityKeyQueryVariables
>;

import { makeMockResponse } from '../../../../../../../../../../graphql/mock-response';

export const makeDupeIndicationBanner_IndicationEntityKeyMockResponse = makeMockResponse<
  DupeIndicationBanner_IndicationEntityKeyQueryVariables,
  DupeIndicationBanner_IndicationEntityKeyQuery
>(DupeIndicationBanner_IndicationEntityKeyDocument);
